"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxPaymentAmount = exports.getMaxPaymentAmountByType = exports.getCompleteVehiclePaymentAmount = void 0;
var products_1 = require("../../constants/products");
var maxPaymentQuantities_1 = require("../../constants/maxPaymentQuantities");
var paymentTypes_1 = require("../../constants/paymentTypes");
var discountMethods_1 = require("./discountMethods");
var quotationMethods_1 = require("./quotationMethods");
var discounts_1 = require("../../constants/discounts");
/** This function is used to reduce Cognitive Complexity from the function below */
function getCompleteVehiclePaymentAmount(quotation, paymentType, autoPxQuantity) {
    if (autoPxQuantity === void 0) { autoPxQuantity = 12; }
    if (paymentType === paymentTypes_1.cashPayment || paymentType === paymentTypes_1.yappyPayment) {
        return maxPaymentQuantities_1.FOR_SIX_PAYMENTS;
    }
    if (paymentType === paymentTypes_1.clavePayment) {
        return maxPaymentQuantities_1.FOR_ONE_PAYMENT;
    }
    // Autopx quantity would now be dynamic, so no constants are needed.
    if (discountMethods_1.appliesAutoPxForPayment(quotation, paymentType)) {
        return autoPxQuantity;
    }
    return maxPaymentQuantities_1.FOR_COMPLETE;
}
exports.getCompleteVehiclePaymentAmount = getCompleteVehiclePaymentAmount;
/**
 * Will return the max amount of allowed payments for the product related to tue quotation and paymentType
 *
 * @param quotation - The source quotation
 * @param paymentType - optional
 */
function getMaxPaymentAmountByType(quotation, paymentType, autoPxQuantity) {
    if (autoPxQuantity === void 0) { autoPxQuantity = 12; }
    switch (quotation.productId) {
        case products_1.COMPLETE_VEHICLE: {
            return getCompleteVehiclePaymentAmount(quotation, paymentType, autoPxQuantity);
        }
        case products_1.THIRD_PARTY_PACK: // VehicleRC_PACK
            if (discountMethods_1.appliesDiscount(quotation) &&
                quotation.packageOption === 3 &&
                paymentType === paymentTypes_1.creditCard) {
                return maxPaymentQuantities_1.FOR_PACK_TCR;
            }
            return maxPaymentQuantities_1.FOR_ONE_PAYMENT;
        default: {
            // VehicleRC
            if (paymentType === paymentTypes_1.clavePayment ||
                paymentType === paymentTypes_1.cashPayment ||
                paymentType === paymentTypes_1.yappyPayment) {
                return maxPaymentQuantities_1.FOR_ONE_PAYMENT;
            }
            return maxPaymentQuantities_1.FOR_THREE_PAYMENTS;
        }
    }
}
exports.getMaxPaymentAmountByType = getMaxPaymentAmountByType;
/**
 * Will return the max amount of allowed payments for the product related to tue quotation
 *
 * @param quotation - The source quotation
 */
function getMaxPaymentAmount(quotation, isDefaultUnit) {
    var _a, _b;
    if (isDefaultUnit === void 0) { isDefaultUnit = false; }
    if (discountMethods_1.appliesAutoPxDiscount(quotation)) {
        return (_b = (_a = quotationMethods_1.defaultUnit(quotation).total.discounts) === null || _a === void 0 ? void 0 : _a.find(function (discount) { return discount.id === discounts_1.AUTOPX_DISCOUNT_ID; })) === null || _b === void 0 ? void 0 : _b.maxQuotas;
    }
    switch (quotation.productId) {
        case products_1.COMPLETE_VEHICLE:
            return maxPaymentQuantities_1.FOR_COMPLETE;
        case products_1.THIRD_PARTY_PACK:
            if (isDefaultUnit) {
                return maxPaymentQuantities_1.FOR_TWO_PAYMENT;
            }
            return maxPaymentQuantities_1.FOR_ONE_PAYMENT;
        default:
            return maxPaymentQuantities_1.FOR_THREE_PAYMENTS;
    }
}
exports.getMaxPaymentAmount = getMaxPaymentAmount;
//# sourceMappingURL=paymentQuantityMethods.js.map